import { render, staticRenderFns } from "./material-zoom.vue?vue&type=template&id=217ac400&"
import script from "./material-zoom.vue?vue&type=script&lang=js&"
export * from "./material-zoom.vue?vue&type=script&lang=js&"
import style0 from "./material-zoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports